import React, { memo, PureComponent } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Topbar from 'app/components/Topbar';
import { healthCheckType } from 'types/utilityTypes';
import { DEFAULT_ROUTES } from 'constants/routes';
import { appConfig } from 'config/customization';

import Maintenance from './layout';
import { getMessage, isApiError } from './utils';
import styles from './styles';

const DEFAULT = appConfig.DEFAULT_ROUTES || DEFAULT_ROUTES;

class MaintenanceContainer extends PureComponent {
  componentDidMount() {
    const { loading, healthCheck } = this.props;
    if (loading && !(healthCheck.healthy === false))
      return this.props.dispatch(push(DEFAULT.RETRIEVE_SESSION));
    return null;
  }

  render() {
    const { healthCheck } = this.props;
    const message = getMessage(healthCheck.message);
    const apiError = isApiError(healthCheck.message);

    return (
      <div style={styles.fullContainer}>
        <Topbar isPublic inMaintenance withoutLogo={apiError} />
        <Maintenance message={message} />
      </div>
    );
  }
}

MaintenanceContainer.propTypes = {
  loading: bool,
  healthCheck: healthCheckType
};

const mapStateToProps = store => ({
  loading: store.auth.sessionLoading,
  healthCheck: store.utility.healthCheck
});

export default connect(mapStateToProps)(memo(MaintenanceContainer));
